import { Record } from 'immutable';

export type ApiDonorStdFile = {
  id: number;
  image: { name: string };
};

const DonorStdFileBase = Record({
  id: 0,
  name: "",
  image: File,
});

export class DonorStdFile extends DonorStdFileBase {
  constructor(apiDonorStdFile?: ApiDonorStdFile) {
    super({
      id: apiDonorStdFile?.id,
      name: apiDonorStdFile?.image.name,
    })
  }
}